export default "__VITE_ASSET__CapWYDlJ__"